import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "nav-wrapper" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = {
  href: "javascript:void(0)",
  ref: "userAvatar"
}
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "nav-update-available nav-update-available--mobile"
}
const _hoisted_9 = {
  key: 1,
  class: "nav-notifications"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["data-tippy-content"]
const _hoisted_12 = {
  key: 0,
  class: "nav-update-available nav-update-available--desktop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DismissLayer = _resolveComponent("DismissLayer")!
  const _component_NotificationPanel = _resolveComponent("NotificationPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DismissLayer, {
      visible: _ctx.isMenuOpen,
      "z-index": 340,
      onDismiss: _ctx.closeMenu
    }, null, 8 /* PROPS */, ["visible", "onDismiss"]),
    _createElementVNode("div", {
      class: _normalizeClass(["sidenav", { loading: _ctx.isLoading, 'menu-open': _ctx.isMenuOpen }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "new-logo" }, [
          _createElementVNode("img", {
            src: "/assets/images/jidoka.svg",
            width: "24",
            height: "28",
            alt: ""
          })
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("a", { href: "javascript:void(0)" }, "Jidoka", -1 /* CACHED */)),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["nav-icon", { open: _ctx.isMenuOpen }]),
            "aria-label": "Toggle navigation",
            "aria-expanded": _ctx.isMenuOpen ? 'true' : 'false',
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", null, null, -1 /* CACHED */),
            _createElementVNode("span", null, null, -1 /* CACHED */),
            _createElementVNode("span", null, null, -1 /* CACHED */),
            _createElementVNode("span", null, null, -1 /* CACHED */)
          ]))], 10 /* CLASS, PROPS */, _hoisted_4)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["menu", { open: _ctx.isMenuOpen }])
        }, [
          _createElementVNode("ul", _hoisted_5, [
            _createCommentVNode(" User Info "),
            _createElementVNode("li", {
              class: _normalizeClass(["user-info", { 'loading-placeholder': _ctx.isLoading }])
            }, [
              _createElementVNode("a", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.userAvatarUrl,
                  height: "32",
                  width: "32",
                  alt: _ctx.isLoading ? 'Loading user avatar' : 'User avatar'
                }, null, 8 /* PROPS */, _hoisted_7),
                _createElementVNode("span", null, _toDisplayString(_ctx.displayName), 1 /* TEXT */)
              ], 512 /* NEED_PATCH */)
            ], 2 /* CLASS */),
            (_ctx.updateAvailable)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "nav-update-available__button",
                    "aria-label": "New version of Jidoka available. Refresh now.",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refreshApplication && _ctx.refreshApplication(...args)))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("span", {
                      class: "icon-update-21 nav-update-available__icon",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */),
                    _createElementVNode("span", null, "Update available", -1 /* CACHED */)
                  ]))])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.user?.uid)
              ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                  _createVNode(_component_NotificationPanel, {
                    uid: _ctx.user.uid
                  }, null, 8 /* PROPS */, ["uid"])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Navigation Links "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link, key) => {
              return (_openBlock(), _createElementBlock("li", {
                key: key,
                class: _normalizeClass({ 'nav-link': true, disabled: key === _ctx.currentPage })
              }, [
                _createElementVNode("a", {
                  href: key === _ctx.currentPage ? 'javascript:void(0)' : `${_ctx.baseURL}${key}`,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
                }, [
                  _createElementVNode("i", {
                    class: "material-icons",
                    "data-tippy-content": key !== _ctx.currentPage ? link.name : undefined
                  }, _toDisplayString(link.icon), 9 /* TEXT, PROPS */, _hoisted_11),
                  _createElementVNode("span", null, _toDisplayString(link.name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_10)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ], 2 /* CLASS */),
        (_ctx.updateAvailable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "nav-update-available__button",
                "data-tippy-content": "New version of Jidoka available",
                "aria-label": "New version of Jidoka available. Refresh now.",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.refreshApplication && _ctx.refreshApplication(...args)))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("span", {
                  class: "icon-update-21 nav-update-available__icon",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)
              ]))])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ]))
}